export default [
  "pay later",
  "free cancellation",
  "free wifi",
  "free breakfast",
  "free parking",
  "pool",
];



// WEBPACK FOOTER //
// ./assets/list/constants/hotelPerks.js